import React from 'react';
import './style.sass';

const Arrow = ({
  arrowColor = 'rgba(16, 160, 222, 1)',
  direction = 'topRight',
  posStyle = { right: '8px' },
  onClick,
}) => {
  const arrowDegMap = {
    topRight: -135,
    topLeft: -225,
    bottomLeft: -315,
    bottomRight: -405,
  };
  return (
    <div
      className="arrow_wrapper"
      style={{
        ...posStyle,
        borderColor: arrowColor,
      }}
      onClick={onClick}
    >
      <div
        className="arrow_base"
        style={{
          transform: `rotate(${arrowDegMap[direction] ?? -135}deg)`,
        }}
      >
        <div
          className="arrow_line"
          style={{
            backgroundColor: arrowColor,
          }}
        ></div>
        <div
          className="arrow_triangle"
          style={{
            borderTopColor: arrowColor,
          }}
        ></div>
      </div>
    </div>
  );
};

export default Arrow;
